const PRODUCTION_WAREHOUSE_HOST = "my.restify.one";

// Стенд определяем по хосту кабинета: прод-кабинет ведёт на прод-меню, всё остальное — на dev.
export const publicMenuHost = (): string =>
    window.location.hostname === PRODUCTION_WAREHOUSE_HOST
        ? "https://menu.restify.one"
        : "https://dev-menu.restify.one";
